import { useStore } from 'models/stores';
import FullPageMessage from './FullPageMessage';

function LanguageDataNotAvailable() {
  const { uiStore } = useStore();
  return (
    <FullPageMessage
      icon="🌎"
      iconLabel="sad"
      main={uiStore.t('job_list_no_language_data')}
      sub={uiStore.t('job_list_no_language_data_sub')}
    />
  );
}

export default LanguageDataNotAvailable;
